import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Package, Check } from "lucide-react";

export default function BusinessCatalogue() {
  const [catalog, setCatalog] = useState([]);
  const [cat, setCat] = useState({ name: "", gtin: "", model: "", warranty_months: "" });

  const load = () => api.get("/business/catalog").then((r) => setCatalog(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const addCatalog = async () => {
    if (!cat.name) return toast.error("Nom du produit requis");
    await api.post("/business/catalog", { ...cat, warranty_months: cat.warranty_months ? parseInt(cat.warranty_months) : null });
    setCat({ name: "", gtin: "", model: "", warranty_months: "" });
    toast.success("Produit ajouté au catalogue");
    load();
  };

  return (
    <div className="space-y-6" data-testid="business-catalogue">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Catalogue produits</h1>
        <p className="text-muted-foreground text-sm mt-1">Chaque produit devient un passeport numérique officiel.</p>
      </div>

      <div className="omy-glass rounded-2xl p-6 space-y-4">
        <h2 className="font-display font-medium flex items-center gap-2"><Package size={18} className="text-indigo-300" /> Ajouter un produit</h2>
        <div className="grid sm:grid-cols-4 gap-3">
          <Input data-testid="catalog-name-input" value={cat.name} onChange={(e) => setCat({ ...cat, name: e.target.value })} className="bg-black/30" placeholder="Nom produit" />
          <Input value={cat.gtin} onChange={(e) => setCat({ ...cat, gtin: e.target.value })} className="bg-black/30" placeholder="GTIN / EAN" />
          <Input value={cat.model} onChange={(e) => setCat({ ...cat, model: e.target.value })} className="bg-black/30" placeholder="Modèle" />
          <Input type="number" value={cat.warranty_months} onChange={(e) => setCat({ ...cat, warranty_months: e.target.value })} className="bg-black/30" placeholder="Garantie (mois)" />
        </div>
        <Button data-testid="catalog-add-btn" onClick={addCatalog} className="bg-indigo-500 hover:bg-indigo-500/90 rounded-full"><Check size={16} className="mr-1.5" /> Ajouter au catalogue</Button>
      </div>

      <div className="space-y-2">
        {catalog.length === 0 && <p className="text-muted-foreground text-sm">Aucun produit dans ton catalogue pour l'instant.</p>}
        {catalog.map((c, i) => (
          <div key={c.id} data-testid={`catalog-item-${i}`} className="flex items-center justify-between rounded-xl bg-black/20 px-4 py-2.5 text-sm">
            <span>{c.name} <span className="text-muted-foreground">· {c.model}</span></span>
            <span className="text-xs text-muted-foreground">{c.gtin} {c.warranty_months && `· garantie ${c.warranty_months} mois`}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
